<template lang="pug" src="./custom-staff-gallery.pug"></template>

<script>

export default {
  props: ['props'],
  data () {
    return {
      list: []
    }
  },
  created () {
    this.list = this.props
  }
}
</script>



// WEBPACK FOOTER //
// custom-staff-gallery.vue?483e342e